<template>
  <div class="m-4 md:mx-8 md:mt-16">
    <div class="flex flex-col md:flex-row md:items-center justify-between mb-4 space-y-2 md:space-y-0">
      <span class="font-semibold text-primario text-lg tracking-wide">{{ $t("lang.msg.clients") }}</span>
      <div class="flex space-x-2 w-full md:max-w-lg">
        <ButtonAction @action="toggleActive" color="gray" large>
          {{ showActive ? $t('lang.msg.viewDisactives') : $t('lang.msg.viewActives') }}
        </ButtonAction>
        <ButtonRedirect route="adminNewClientDetail" color="gray">
          {{ $t('lang.msg.add') }}
        </ButtonRedirect>
      </div>
    </div>
    <datatable
      :data="data"
      :headers="headers"
      @on-row-click="openItemView"
    />
  </div>
</template>

<script>
import AdminMixin from "@/components/mixins/AdminMixin";
import DataTable from "@/components/shared/DataTable";

export default {
  name: "Clients",
  mixins: [AdminMixin],
  components: {
    datatable: DataTable
  },
  data() {
    return {
      data: [],
      allData: [],
      headers: {
        idClient: "#",
        clientName: this.$t("lang.fields.name"),
        abbreviation: this.$t("lang.fields.abbreviation"),
        groupName: this.$t("lang.msg.group"),
        active: {
          name: this.$t("lang.msg.active"),
          type: Boolean
        }
      }
    };
  },
  created() {
    this.fetchClients();
  },
  methods: {
    fetchClients() {
      this.$axios.get(`api/Clients/GetAllClient`).then((response) => {
        this.data = response.data.filter(element=>{
        return element.active==this.showActive;});
        this.allData = response.data;
      });
    },
    openItemView(item) {
      this.$router.push({
        name: "adminClientDetail",
        params: {
          idClient: item.idClient
        }
      });
    }
  }
};
</script>